"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../../common/Modal/Modal"));
var _APIcon = _interopRequireDefault(require("../../../common/APIcon"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./DepositReferenceIdModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var depositReferenceIdModalClasses = (0, _cssClassesHelper.getBEMClasses)('deposit-reference-id-modal');
var DepositReferenceIdModal = function DepositReferenceIdModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: !!(props.referenceCode && props.isOpen),
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: depositReferenceIdModalClasses('header-content')
    }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: 'depositWithBorder',
      size: 44,
      customClass: depositReferenceIdModalClasses('icon')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: depositReferenceIdModalClasses('header-title')
    }, "".concat(t("Deposit"), " ").concat(props.ProductSymbol))),
    close: props.close,
    footer: {
      buttonText: t("OK"),
      buttonStyle: 'additive',
      onClick: function onClick() {
        return props.close;
      }
    },
    customClass: depositReferenceIdModalClasses()
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: depositReferenceIdModalClasses('title')
  }, t("Your deposit ticket has been created successfully.")), /*#__PURE__*/_react["default"].createElement("div", {
    className: depositReferenceIdModalClasses('reference-code-container')
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: depositReferenceIdModalClasses('reference-code-title')
  }, t("Please note the following deposit ticket ID for your reference:")), /*#__PURE__*/_react["default"].createElement("p", {
    className: depositReferenceIdModalClasses('reference-code')
  }, props.referenceCode)));
};
DepositReferenceIdModal.propTypes = {
  close: _propTypes["default"].func.isRequired
};
DepositReferenceIdModal.defaultProps = {
  referenceCode: ''
};
var _default = exports["default"] = DepositReferenceIdModal;